<template>
  <div class="services">
    <b-container>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center flex-column">
          <p class="services__title-small mb-0">NextGen Garage Door Repairs</p>
          <p class="services__title">
            Trusted Garage Door Repair & Installation by NextGen Garage Door
            Repairs
          </p>
          <p class="services__description mb-4">
            NextGen Garage Door Repairs proudly offers professional garage door
            services, including:
          </p>
          <ul class="services__list mt-2">
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>New garage door installations (Residentail and Commercial)</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span
                >Replacement of old <br class="d-md-none d-flex" />
                or damaged doors</span
              >
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Broken spring replacement</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Cable repair & replacement</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Panel replacement</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Roller and hinge repair</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Track alignment and repair</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Opener repair and troubleshooting</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span>Remote and keypad programming</span>
            </li>
            <li>
              <svg
                aria-hidden="true"
                width="20"
                height="20"
                class="e-font-icon-svg e-fas-check-circle"
                viewBox="0 0 512 512"
              >
                <path
                  d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                ></path>
              </svg>
              <span
                >Fast response for stuck <br class="d-md-none d-flex" />
                or non-functioning doors</span
              >
            </li>
          </ul>
          <p class="services__description mt-4">
            NextGen Garage Door Repairs services and repairs all types of garage
            doors with expertise. With years of hands-on experience, we’ve
            solved every kind of garage door issue.
          </p>
          <p class="services__contact mt-2">
            CONTACT US AT
            <strong>
              <a href="tel:5514080587" class="text-dark"
                >(551) 408-0587</a
              ></strong
            >
            for fast and professional service.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ServicesSection",
};
</script>

<style lang="scss" scoped>
.services {
  padding-top: 40px;
  background: #ffffff;

  &__title-small {
    font-size: 14px;
    color: #0d47a1 !important;
    font-weight: 600;
  }

  &__title {
    font-size: 32px;
    color: #1d1729;
    font-weight: 700;
    line-height: 40px;
  }
  @media (max-width: 700px) {
    &__title {
      font-size: 26px;
      line-height: 32px;
    }
  }
  &__description {
    font-size: 20px;
    font-weight: 400;
  }
  &__list {
    margin: 0;
    padding-left: 0;

    li {
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
      margin-bottom: 10px;
      display: flex;
      align-items: baseline;
      list-style: none;

      svg {
        margin-right: 8px;
        fill: #0d47a1;
      }
    }
  }

  &__contact {
    font-size: 20px;
    font-weight: 600;
    color: #1d1729;
  }
}
</style>
